export default "__VITE_ASSET__ilT5jFrv__"